var map = {
	"./examples/button.md": 225,
	"./examples/sample.md": 226,
	"./examples/switch.md": 227
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 212;



//////////////////
// WEBPACK FOOTER
// ./docs ^\.\/examples.*\.md$
// module id = 212
// module chunks = 0